import { InjectionToken } from '@angular/core';
import { LibConfiguration } from './lib-configuration';

export const LIB_CONFIG = new InjectionToken<LibConfiguration>('LIB_CONFOG');
